import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=38b61829&scoped=true"
import script from "./complete.vue?vue&type=script&lang=ts"
export * from "./complete.vue?vue&type=script&lang=ts"
import style0 from "./complete.vue?vue&type=style&index=0&id=38b61829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b61829",
  null
  
)

export default component.exports